<template>
  <main>
    <HeaderNews
        buttonTitle="Editar"
        buttonTitle2="Excluir"
        title="Notícias"
        text="Cadastre sua notícia"
        @voltar="goToRoute('/noticias')"
        :haveAction="false"
        :haveBack="true"
    />

    <v-container style="max-width: unset" class="pa-4">
      <section>
        <v-file-input
            style="display: none"
            id="image"
            accept="image/png, image/jpeg, image/jpg"
            :label="'Nenhuma imagem selecionada'"
            filled
            prepend-icon="mdi-camera"
            @change="setImageMobile"
            required
        >
        </v-file-input>

        <div
            :key="imageKey"
            class="d-flex flex-column align-center justify-center"
        >
          <p class="ma-0 py-2 text-center">Imagem principal</p>
          <v-hover v-slot="{ hover }" v-if="news.image != null">
            <v-img
                :src="news.image"
                style="
                            border-radius: 5px !important;
                            opacity: 0.7;
                            cursor: pointer;"
                height="180"
                width="300"
                :class="hover ? 'elevation-5 mx-2' : 'mx-2'"
            >
              <v-expand-transition>
                <div
                    v-if="hover"
                    class="d-flex flex-column justify-center align-center"
                    style="height: 100%; background: rgba(188, 0, 0, 0.6)"
                    @click="openPicker('image')"
                >
                  <v-icon size="26" color="white">mdi-pen</v-icon>
                  <span class="edit-photo">Alterar foto</span>
                </div>
              </v-expand-transition>
            </v-img>
          </v-hover>

          <span
              class="delete-photo"
              v-if="news.image != null"
              @click="(news.image = null)"
          >
          Excluir
        </span>

          <div class="d-flex flex-column align-center" v-if="news.image == null">
            <v-hover>
              <div class="image-container mx-2" @click="openPicker('image')">
                <div class="d-flex flex-column align-center">
                  <v-img
                      src="../../../assets/add_photo.svg"
                      contain
                      max-width="46"
                  >
                  </v-img>
                  <span class="photo-field">Adicionar Foto</span>
                </div>
              </div>
            </v-hover>
          </div>
        </div>
      </section>

      <v-row cols="12">
        <v-col class="" cols="12">
          <span class=" label-details">Título da notícia</span>
          <v-text-field
              outlined
              v-model="news.title"
              height="52"
              style="border: 1px solid #979797; border-radius: 5px;"
              maxlength="125"
              background-color="#F5F5F5"
              hide-details
              placeholder="Título da notícia"
              required
          ></v-text-field>
          <br/>
        </v-col>
      </v-row>

      <v-row cols="12" class="mb-10">
        <v-col class="" cols="12">
          <h3 class=" label-details mb-1">Notícia</h3>
          <quill-editor
              :content="content"
              @change="onEditorChange($event)"
              ref="myQuill"
          >
          </quill-editor>
        </v-col>
      </v-row>

      <v-row class="">
        <v-col cols="12" md="6" sm="6" lg="6">
          <v-btn
              width="50%"
              class="cancel-button"
              outlined
              block
              height="45"
              style="border-radius: 5px"
              @click="goToRoute('/noticias')"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" sm="6" lg="6">
          <v-btn
              width="50%"
              class="secondary-button"
              block
              style="font-weight: bold !important"
              @click="submit()"
          >
            {{ newsId ? 'Atualizar Notícia' : 'Cadastrar Notícia' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<style scoped>
.delete-photo {
  cursor: pointer;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px !important;
  height: 180px;
  background: #dadada;
  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 5px !important;
}

@media (max-width: 600px) {
  .image-container {
    width: 200%;
  }
}

@media (max-width: 900px) {
  .image-container {
    width: 200%;
  }
}

@media (max-width: 300px) {
  .image-container {
    width: 145%;
  }
}

.cancel-button {
  border-radius: 7.5px !important;
  transition: 0.3s !important;
}

.cancel-button:hover {
  color: white !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2) !important;
}
</style>

<script>
import HeaderNews from "./components/HeaderNews.vue";
import ApiService from "../../../services/ApiService";
import Vue from "vue";
import moment from "moment";

export default {
  components: {
    HeaderNews,
  },
  data: () => ({
    content: "",
    imageKey: 0,
    loading: false,
    newsId: null,
    apiService: new ApiService(),
    news: {
      title: null,
      image: null,
      description: null,
    }
  }),
  async mounted() {
    this.newsId = this.$route.query.id
    if(this.newsId) {
      await this.getNews()
    }
  },
  methods: {
    onEditorChange({quill, html, text}) {
      this.news.description = html
    },

    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        const env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    openPicker(idInput) {
      document.querySelector(`#${idInput}`).click();
    },

    setImageMobile(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.news.image = reader.result;
        };
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    async submit() {
      try {
        if (this.news.title === null || this.news.image === null || this.news.description === null) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Preencha todos os campos corretamente.",
            trace: null,
          });
        return
        }
        if(this.newsId) {
          this.apiService
              .put('news/update', this.news)
              .then((response) => {
                Vue.$globalEvent.$emit("onFlashMessage", {
                  type: "success",
                  title: "Banner cadastrado com sucesso",
                  message: `${response.message ? response.message : 'Notícia atualizada com sucesso'}`,
                  trace: null,
                });
                this.loading = false;
                this.goToRoute("/noticias");
              })
              .catch((error) => {
                Vue.$globalEvent.$emit("onFlashMessage", {
                  type: "error",
                  title: "",
                  message: `${error.message ? error.message : 'Não foi possível atualizar a notícia'}`,
                  trace: null,
                });
              })
        } else {
          this.apiService
              .post('news/add', this.news)
              .then((response) => {
                Vue.$globalEvent.$emit("onFlashMessage", {
                  type: "success",
                  title: "Banner cadastrado com sucesso",
                  message: `${response.message ? response.message : 'Notícia cadastrada com sucesso'}`,
                  trace: null,
                });
                this.loading = false;
                this.goToRoute("/noticias");
              })
              .catch((error) => {
                Vue.$globalEvent.$emit("onFlashMessage", {
                  type: "error",
                  title: "",
                  message: `${error.message ? error.message : 'Não foi possível cadastrar notícia'}`,
                  trace: null,
                });
              })
        }
      } catch (error) {
      }
    },

    async getNews() {
      try {
        this.apiService
            .get(`news/get-one?id=${this.newsId}`)
            .then((response) => {
              this.news = response.content;
              this.content = this.news.description
            })
            .catch((error) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: `${error.message ? error.message : 'Não foi possível atualizar a notícia'}`,
                trace: null,
              });
            })

      } catch (error) {
      }
    }
  },

  watch: {},
};
</script>
